"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domainIcon = exports.IconSize = void 0;

var _core = require("@emotion/core");

var IconSize;
exports.IconSize = IconSize;

(function (IconSize) {
  IconSize["regular"] = "24px";
  IconSize["small"] = "18px";
})(IconSize || (exports.IconSize = IconSize = {}));

var iconSize = function iconSize(size) {
  return /*#__PURE__*/(0, _core.css)("width:", IconSize[size], ";height:", IconSize[size], ";");
};

var domainIcon = function domainIcon(size) {
  return /*#__PURE__*/(0, _core.css)("stroke-linejoin:round;stroke-linecap:round;fill:none;vertical-align:middle;use{pointer-events:none;}", size && iconSize(size), ";");
};

exports.domainIcon = domainIcon;